import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const saleManagementRoutes: RouteConfig[] = [
  {
    path: "/sales-management",
    component: Layout,
    redirect: "/sales-management",
    name: "SaleManagement",
    meta: {
      title: "saleManagement",
      icon: "el-icon-s-goods",
      alwaysShow: true
    },
    children: [
      {
        path: "factory-loading-plan",
        component: () =>
          import("@/views/sales-management/FactoryLoadingPlanManagement.vue"),
        name: "FactoryLoadingPlan",
        meta: { title: "factoryLoadingPlan" }
      },
      {
        path: "hengan-loading-plan",
        component: () =>
          import("@/views/outbound-management/HenganLoadingPlanManagement.vue"),
        name: "HenganLoadingPlan",
        meta: {
          title: "henganLoadingPlan"
        }
      },
      {
        path: ":id",
        name: "HenganLoadingPlanDetail1",
        component: () =>
          import("@/views/outbound-management/HenganLoadingPlanDetail.vue"),
        meta: { title: "henganLoadingPlanDetail", hidden: true }
      },
      {
        path: "/bookingOrderManagement",
        component: () =>
          import("@/views/sales-management/SalesBookingOrderManagement.vue"),
        name: "SalesBookingOrderManagement",
        meta: { title: "bookingOrderManagement" }
      },
      {
        path: "list",
        component: () =>
          import("@/views/sales-management/customer/list/index.vue"),
        name: "CustomerManagement",
        meta: { title: "CustomerManagement" }
      },
      {
        path: ":type/:parentId/packing-list/",
        name: "PackingList",
        component: () =>
          import("@/views/inbound-management/HqPackingListManagement.vue"),
        meta: { title: "packingListManagement", hidden: true }
      },
      {
        path: ":type/:parentId/packing-list/:hqPackingListId",
        name: "HqPackingListDetail",
        component: () =>
          import("@/views/inbound-management/HqPackingListDetail.vue"),
        meta: { title: "hqPackingListDetail", hidden: true }
      },
      // {
      //   path: ":type/:parentId/packing-list/:hqPackingListId/edit",
      //   name: "HqPackingListDetailForEdit",
      //   component: () =>
      //     import("@/views/inbound-management/HqPackingListDetailForEdit.vue"),
      //   meta: { title: "editHqPackingList", hidden: true }
      // },
      {
        path: ":bizType/:objectId/image-management",
        name: "ImageManagement",
        component: () =>
          import("@/views/inbound-management/ImageManagement.vue"),
        meta: { title: "imageManagement", hidden: true }
      },
      {
        path: "/askingForQuotation",
        name: "askingForQuotation",
        component: () =>
          import("@/views/system-management/permission/index.vue"),
        meta: { title: "askingForQuotation",hidden: true, },
        redirect: "/askingForQuotationManagement",
        children: [
          // {
          //   // 询价单管理
          //   path: "/askingForQuotationManagement",
          //   name: "askingForQuotationManagement",
          //   component: () =>
          //     import("@/views-oms/asking-for-quotation-management/Index.vue"),
          //   meta: { title: "askingForQuotationManagement" }
          // },

          // {
          //   // 客人下单产品库
          //   path: "/orderProductLibrary",
          //   name: "orderProductLibrary",
          //   component: () =>
          //     import("@/views-oms/asking-for-quotation-management/OrderProduct.vue"),
          //   meta: { title: "orderProductLibrary" }
          // },
          // {
          //   // 客人报价产品库
          //   path: "/quotationProductLibrary",
          //   name: "quotationProductLibrary",
          //   component: () =>
          //     import("@/views-oms/asking-for-quotation-management/AskProduct.vue"),
          //   meta: { title: "quotationProductLibrary" }
          // }
          // {
          //     path: "/quotationProductLibrary",
          //     name: "quotationProductLibrary",
          //     component: () =>
          //         import("@/views/app-version/AppVersion.vue"),
          //     meta: { title: "quotationProductLibrary" },
          // },
        ]
      },
      {
        path: "/salesOrderManagement",
        name: "salesOrderManagement",
        component: () =>
          import("@/views/system-management/permission/index.vue"),
        redirect: "/salesOrder",
        meta: { title: "salesOrderManagement" },
        children: [
          {
            path: "/salesOrder",
            name: "salesOrder",
            component: () =>
              import("@/views-oms/sales-order-management/order/list.vue"),
            meta: { title: "salesOrder" }
          },
          {
            path: "/PIDetails",
            name: "PIDetails",
            component: () =>
              import("@/views-oms/sales-order-management/order/pi-details/index.vue"),
            meta: { title: "PIDetails", hidden: true, activeMenu: "/salesOrder" }
          },
          {
            path: "/revisePI",
            name: "revisePI",
            component: () =>
              import("@/views-oms/sales-order-management/order/pi-details/edit.vue"),
            meta: { title: "revisePI", hidden: true, activeMenu: "/salesOrder" }
          },
          {
            path: "/abnormalDeliveryHandling",
            name: "abnormalDeliveryHandling",
            component: () =>
              import("@/views-oms/sales-order-management/order/abnormal-delivery-handling/index.vue"),
            meta: { title: "abnormalDeliveryHandling", hidden: true, activeMenu: "/salesOrder" }
          },
          {
            path: "/customerInventoryManagement",
            name: "customerInventoryManagement",
            component: () =>
              import("@/views-oms/sales-order-management/order/customer-inventory/index.vue"),
            meta: { title: "customerInventoryManagement", hidden: true, activeMenu: "/salesOrder" }
          },
          {
            path: "/orderManagement",
            name: "orderManagement",
            component: () =>
              import("@/views-oms/sales-order-management/order/order-management/index.vue"),
            meta: { title: "orderManagement", hidden: true, activeMenu: "/salesOrder" }
          },

          {
            path: "/orderDetails",
            name: "orderDetails",
            component: () =>
              import("@/views-oms/sales-order-management/order/order-details/index.vue"),
            meta: { title: "orderDetails", hidden: true, activeMenu: "/salesOrder" }
          },
          {
            path: "/PIPaymentManagement",
            name: "PIPaymentManagement",
            component: () =>
              import("@/views-oms/sales-order-management/order/pi-payment/index.vue"),
            meta: { title: "PIPaymentManagement", hidden: true, activeMenu: "/salesOrder" }
          },

          {
            path: "/quotationAudit",
            name: "quotationAudit",
            component: () =>
              import("@/views-oms/sales-order-management/quotation/list.vue"),
            meta: { title: "quotationAudit" }
          },
          {
            path: "/quotationDetails",
            name: "quotationDetails",
            component: () =>
              import("@/views-oms/sales-order-management/quotation/Details.vue"),
            meta: { title: "quotationDetails", hidden: true, activeMenu: "/quotationAudit" }
          },
          {
            path: "/editQuotation",
            name: "editQuotation",
            component: () =>
              import("@/views-oms/sales-order-management/quotation/Edit.vue"),
            meta: { title: "editQuotation", hidden: true, activeMenu: "/quotationAudit" }
          }
        ]
      },
      // 报价管理
      {
        path: "/quotationManagement",
        name: "quotationManagement",
        component: () =>
          import("@/views-oms/asking-for-quotation-management/QuotationManagement.vue"),
        meta: { title: "quotationManagement", hidden: true }
      },
      // 包装资料管理
      {
        path: "/packageInfoManagement",
        name: "packageInfoManagement",
        component: () =>
          import("@/views-oms/package-info-management/index.vue"),
        meta: { title: "packageInfoManagement" },
      },
      {
        path: "/packingMaterialManagement",
        name: "packingMaterialManagement",
        component: () =>
          import("@/views-oms/package-info-management/material/index.vue"),
        meta: { title: "packingMaterialManagement", hidden: true, activeMenu: "/packageInfoManagement" }
      },
      // 额外信息管理
      {
        path: "/otherInfoManagement",
        name: "otherInfoManagement",
        component: () =>
          import("@/views-oms/package-info-management/otherInfoManagement/index.vue"),
        meta: { title: "otherInfoManagement", hidden: true, activeMenu: "/otherInfoManagement" }
      },{ // 客人IV管理
        path: "/customer-iv-management",
        name: "customerIvManagement",
        component: () =>
          import("@/views-oms/sales-order-management/customer/customer-iv-management.vue"),
        meta: { title: "customerIvManagement" }
      },{ // 客人IV管理-查看详情
        path: "/customer-iv-managementInfo",
        name: "customerIvManagementInfo",
        component: () =>
          import("@/views-oms/sales-order-management/customer/customer-iv-managementInfo.vue"),
        meta: { title: "customerIvManagementInfo",hidden: true, }
      }
    ]
  }
];

export default saleManagementRoutes;
